
function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_USER = '/user';
const ROOTS_CONTRACT = '/contract';
const ROOTS_TRANSFER = '/transfer';
const ROOTS_MATCH = '/match';
const ROOTS_WORK = '/work';
const ROOTS_FLIERS = '/fliers';
const ROOTS_AI = '/ai';
const ROOTS_SCOUT = '/scout';
const ROOTS_SOURCING = '/sourcing';
const ROOTS_SALES = '/sales';
const ROOTS_CHURN = '/churn';
const ROOTS_CANDIDATE = '/candidate';
const ROOTS_COMPANY = '/company';
const ROOTS_PROJECT = '/project';
const ROOTS_PUSH = '/push';
const ROOTS_MEETING = '/meeting';
const ROOTS_TOOL = '/tool';
const ROOTS_GOAL = '/goal';
const ROOTS_ESIGNATURE = '/esignature';

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
};

export const PATH_USER = {
  root: ROOTS_USER,
  detail: path(ROOTS_USER, '/detail'),
}

export const PATH_PAGE = {
  page404: '/404',
  page500: '/500',
};

export const PATH_CONTRACT = {
  root: ROOTS_CONTRACT,
  list: path(ROOTS_CONTRACT, '/list'),
  renewal: path(ROOTS_CONTRACT, '/renewal'),
}

export const PATH_TRANSFER = {
  root: ROOTS_TRANSFER,
}

export const PATH_LOGIN = '/login';

export const PATH_MATCH = {
  root: ROOTS_MATCH,
};

export const PATH_WORK = {
  root: ROOTS_WORK,
};

export const PATH_FLIERS = {
  root: ROOTS_FLIERS,
};

export const PATH_AI = {
  root: ROOTS_AI,
};

export const PATH_SCOUT = {
  root: ROOTS_SCOUT,
};

export const PATH_SOURCING = {
  root: ROOTS_SOURCING,
};

export const PATH_SALES = {
  inbound: path(ROOTS_SALES, '/inbound'),
};

export const PATH_CHURN = {
  root: ROOTS_CHURN,
};

export const PATH_CANDIDATE = {
  root: ROOTS_CANDIDATE,
};

export const PATH_COMPANY = {
  root: ROOTS_COMPANY,
};

export const PATH_PROJECT = {
  root: ROOTS_PROJECT,
};

export const PATH_PUSH = {
  root: ROOTS_PUSH,
};

export const PATH_MEETING = {
  root: ROOTS_MEETING,
};

export const PATH_TOOL = {
  root: ROOTS_TOOL,
};

export const PATH_GOAL = {
  root: ROOTS_GOAL,
};

export const PATH_ESIGNATURE = {
  root: ROOTS_ESIGNATURE,
};
